// extracted by mini-css-extract-plugin
export default {"container":"AttachmentsQuoteForm_container__+GQHT","buttonAddFile":"AttachmentsQuoteForm_buttonAddFile__guNzs"};